import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link } from "react-router-dom";

const slides = [
  {
    src: "img/iphone13pro.webp",
    alt: "iPhone 13 Pro",
    link: "/product/apple",
  },
  {
    src: "img/0822-M020-23-samsung-galaxy-ultra-desktab.jpg",
    alt: "Samsung Galaxy Ultra",
    link: "/product/samsung",
  },
  {
    src: "img/iphone13pro.webp",
    alt: "iPhone 13 Pro",
    link: "/product/apple",
  },
  {
    src: "img/0822-M020-23-samsung-galaxy-ultra-desktab.jpg",
    alt: "Samsung Galaxy Ultra",
    link: "/product/samsung",
  },
];

const banner = {
  src: "wintersalevertical.jpg",
  link: "/",
  alt: "Winter Sale Banner",
};

const Special: React.FC = () => {
  return (
    <div className="w-full flex gap-2 lg:gap-10 items-stretch px-5 py-5 lg:px-36">
      <Swiper
        modules={[Navigation, Pagination]}
        navigation
        pagination={{ clickable: true }}
        className="w-[80%] h-auto bg-[#DDFFF7] rounded-2xl flex"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index} className="flex justify-center items-center">
            <Link to={slide.link || "#"}>
              <img
                src={slide.src}
                alt={slide.alt}
                className="w-full h-auto object-contain rounded-2xl"
              />
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>

      <Link
        to={banner.link}
        className="w-[20%] bg-cover bg-no-repeat bg-center rounded-2xl overflow-hidden"
        style={{
          backgroundImage: `url(${banner.src})`,
          height: "auto",
        }}
        aria-label={banner.alt}
      ></Link>
    </div>
  );
};

export default Special;
